import {
  getMortgageInsuranceConfig,
  mortgageInsuranceSectionFieldsKeys,
} from 'app/pages/loanApplication/tabs/propertyAndLoan/EditModal/Content/MainContent/MortgageInsurance/MortgageInsurance.config';
import { FormNames } from 'app/services/autoLockForms/autoLockForms.constants';
import _ from 'lodash';

export const MORTGAGE_INSURANCE_FIELD_NAMES = new Set(mortgageInsuranceSectionFieldsKeys);

export const getMortgageInsuranceGroups = mortgageInsuranceContext =>
  getMortgageInsuranceConfig({
    miProductType: mortgageInsuranceContext.miProductType,
    miCompanyType: mortgageInsuranceContext.miCompanyType,
    onCompanyTypeChange: mortgageInsuranceContext.onCompanyTypeChange,
    storedValues: mortgageInsuranceContext.storedValues,
    isOrderOutcomeReadOnly: mortgageInsuranceContext.isOrderOutcomeReadOnly,
  }).groups;

export const getMortgageInsuranceConfigFieldsForContext = mortgageInsuranceContext => {
  if (!mortgageInsuranceContext?.isEnabled) {
    return {};
  }

  return _.keyBy(
    getMortgageInsuranceGroups(mortgageInsuranceContext).flatMap(group => group.fields),
    'fieldId',
  );
};

export const checkIsMortgageInsuranceOnly = placedLoanAndLockFormNames =>
  !!placedLoanAndLockFormNames.size &&
  [...placedLoanAndLockFormNames].every(formName => formName === FormNames.MORTGAGE_INSURANCE);

export const checkShouldSeedMortgageInsurance = ({ loanFieldGroups, mortgageInsuranceContext }) =>
  !!mortgageInsuranceContext?.isEnabled &&
  (loanFieldGroups ?? []).some(group => group.formName === FormNames.MORTGAGE_INSURANCE);
